import { mapGetters } from 'vuex';
import { getIdFromURL } from 'vue-youtube-embed';
import collapsiblePanel from '@/components/collapsible-panel/collapsible-panel.vue';
import contentHeader from '@/components/generics/content-header/content-header.vue';
import scrollTo from '@/utils/scrollTo';

export default {
  props: {
    asWidget: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    contentHeader,
    collapsiblePanel,
  },
  data() {
    return {
      expanded: false,
      accordion: 'video-0',
      videos: [
        { title: 'Buying and Selling Shares', video: 'https://www.youtube.com/watch?v=h57BM4abHJ4', id: 'video-0' },
        { title: 'Navigating the Site', video: 'https://www.youtube.com/watch?v=muJmhHeVJ_w', id: 'video-1' },
        { title: 'Opening an Account', video: 'https://www.youtube.com/watch?v=NfWU0Wiixuo', id: 'video-2' },
      ],
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
  },
  methods: {
    getYoutubeIdFromUrl(url) {
      return getIdFromURL(url);
    },
    accordionOpen(e) {
      this.accordion = e;

      if (e !== null) {
        setTimeout(() => scrollTo(document.getElementById(e), 0), 50);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/support/videos/videos.js